import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
// import { useSelector } from "react-redux";

import search from "../../assets/search.png";
import warning from "../../assets/warning.png";
import Footer from "../../components/Footer/index";

function FAQTab(props) {
  const { allFAQList, filteredFAQList, setFilteredFAQList } =
    props;

  const [searchText, setSearchText] = useState("");
  const [deviceWidth, setDeviceWidth] = useState(window?.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window?.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (searchText === "") {
      setFilteredFAQList(allFAQList);
      return;
    }

    const searchTextLower = searchText.toLowerCase();

    const questionsFiltered = allFAQList
      .map((item) => {
        const filteredFaqItems = item?.faqItem?.filter(
          (faq) =>
            faq?.question?.toLowerCase()?.includes(searchTextLower) ||
            faq?.answer?.toLowerCase()?.includes(searchTextLower)
        );

        const topicMatches = item?.topic?.toLowerCase()?.includes(searchTextLower);

        if (topicMatches || filteredFaqItems?.length > 0) {
          return {
            topic: item?.topic,
            faqItem: topicMatches ? item?.faqItem : filteredFaqItems,
          };
        }
        return null;
      })
      .filter((item) => item !== null);

    setFilteredFAQList(questionsFiltered);
  }, [searchText, allFAQList]);

  return (
    <Container>
      <StyledHeader>
        <span className="header-text">FAQ</span>
      </StyledHeader>
      <div className="content">
        <ContentView
          filteredFaqList={filteredFAQList}
          allFAQList={allFAQList}
          setSearchText={setSearchText}
          searchText={searchText}
        />
      </div>
      <Footer />
    </Container>
  );
}

export default FAQTab;

function ContentView({
  filteredFaqList,
  allFAQList,
  setSearchText,
  searchText,
}) {
  const highlightText = (text, highlightTerm) => {
    if (!highlightTerm.trim()) {
      return text;
    }
    const regex = new RegExp(`(${highlightTerm})`, "gi");
    return text.replace(
      regex,
      `<mark style="background-color: #F3AE2A; color: black;">$1</mark>`
    );
  };

  const renderHighlightedText = (text, searchText) => {
    const highlightedHTML = highlightText(text, searchText);
    return <span dangerouslySetInnerHTML={{ __html: highlightedHTML }} />;
  };

  const renderFAQList = ({ topic, faqItem }, index) => (
    <div key={index}>
      <div key={index} className="anchor-target" id={topic} />
      <div className="answers-section" id={topic}>
        {faqItem.map((item, index) => (
          <div className="answers-item" key={index}>
            <span className="question-text">
              {renderHighlightedText(item?.question, searchText)}
            </span>
            <span className="answer-text">
              {renderHighlightedText(item?.answer, searchText)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <StyledContentContainer>
      <div className="answers-container">
        <StyledSearch width="360px">
          <div>
            <input
              type="text"
              className="search-input"
              placeholder="Busque por palavra-chave"
              onChange={(e) => setSearchText(e?.target?.value)}
            />
            <img className="search-icon" src={search} alt="search-icon" />
          </div>
        </StyledSearch>
        {filteredFaqList?.length === 0 ? (
          <>
            <div className="empty-content">
              <img src={warning} alt="warning-icon" className="empty-icon" />
              <div className="text-section">
                <span className="empty-text">
                  Não foi encontrado nenhum resultado relacionado ao termo{" "}
                  {searchText}.
                </span>
                <span className="empty-text">
                  Por favor, tente novamente. Se preferir, navegue pelos temas
                  abaixo:
                </span>
              </div>
            </div>
            {allFAQList.map(renderFAQList)}
          </>
        ) : (
          filteredFaqList.map(renderFAQList)
        )}
      </div>
    </StyledContentContainer>
  );
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #006437;
  min-height: 100vh;
  min-width: 100vw;
  margin: 88px 0 0 0;

  @media (max-width: 768px) {
    margin: 45px 0 0 0;
  }

  .content {
    flex: 1;
  }
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  width: 100vw;
  margin: 45px 0px;

  .answers-container {
    display: flex;
    flex-direction: column;
    width: 60%;
    padding: 0px 24px 24px 24px;
    background-color: #006437;
    height: 100%;
    overflow-y: auto;
    min-height: 85vh;

    @media (max-width: 900px) {
      width: 100%;
    }

    .empty-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 16px 0px;
      gap: 24px;
      margin-top: 60px;

      .empty-icon {
        width: 86px;
        height: 90px;
      }

      .text-section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
      }

      .empty-text {
        font-family: "Roboto";
        font-size: 18px;
        line-height: 28px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.64);
        text-align: start;
      }
    }

    .answers-section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      margin-top: 60px;

      .answers-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
      }

      .question-text {
        font-family: "Roboto Condensed";
        font-size: 21px;
        line-height: 21px;
        font-weight: 600;
        text-transform: uppercase;
        color: #ffffff;
        padding: 24px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        margin: 24px 0;
        width: 100%;
      }

      .answer-text {
        font-family: "Roboto";
        font-size: 18px;
        line-height: 28px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.64);
        padding-bottom: 24px;
        text-align: justify;
        width: 100%;
      }
    }
  }
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-family: "Roboto Condensed";
    font-size: 32px;
    line-height: 32px;
    font-weight: 900;
    text-align: center;
    text-transform: uppercase;
    color: #ffffff;
  }
`;

const StyledSearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => props.width};
    background-color: #fff;
    border-radius: 8px;
    padding: 8px;

    @media (max-width: 768px) {
      width: 100%;
    }

    .search-input {
      flex-grow: 1;
      border: none;
      outline: none;
      padding: 8px 16px;
      color: #003b21;
      font-family: "Roboto";
    }

    .search-icon {
      color: #003b21;
      width: 24px;
      height: 32px;
      margin-right: 16px;
    }
  }
`;
